import api from '@/api'

const { $pricing, $academic, $student } = api;

export const { $sanction, $subjects, $departments } = $academic;
export const { $sanctionStudents, $billingData, $materias, $examenes } = $student;
export const { $types } = $pricing;
